/**
 * Slug conversions for the SP4 story-first Analytics page.
 *
 * Convention (see `CyberFindIntelHub/docs/superpowers/specs/2026-04-19-sp4-…`
 * §4.4 + §11): the URL-visible "kebab" form is what users see; the backend
 * enum form is underscored. Analytics widgets emit kebab slugs into `URLSearchParams`
 * then convert to underscore at the fetch boundary (or vice versa when parsing).
 *
 * Phase 5 ontology follow-up: once `@intelhub/shared/ontology` exports the
 * kebab↔underscore maps, we drop these wrappers in favour of the shared helpers.
 */

export function toKebab(s: string): string {
  return s.replace(/_/g, '-')
}

export function toUnderscore(s: string): string {
  return s.replace(/-/g, '_')
}
